var f = Object.defineProperty, p = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, w = Object.prototype.propertyIsEnumerable;
var m = (t, o, e) => o in t ? f(t, o, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[o] = e, i = (t, o) => {
  for (var e in o || (o = {}))
    s.call(o, e) && m(t, e, o[e]);
  if (r)
    for (var e of r(o))
      w.call(o, e) && m(t, e, o[e]);
  return t;
}, a = (t, o) => p(t, c(o));
import g, { forwardRef as n } from "react";
import d from "../lib/IconBase.mjs";
import l from "../defs/TwitterLogo.mjs";
const L = n((t, o) => /* @__PURE__ */ g.createElement(d, a(i({ ref: o }, t), { weights: l })));
L.displayName = "TwitterLogo";
export {
  L as TwitterLogo
};
